var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCloud = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2395 9H17.6635C16.9915 7 15.6475 5.3 13.8235 4.2C11.9035 3 9.59952 2.7 7.39152 3.3C2.78352 4.7 -0.000477791 9.5 1.15152 14.2C2.11152 18.2 5.56752 21 9.59952 21H18.2395C21.5035 21 23.9995 18.4 23.9995 15C23.9995 11.6 21.5035 9 18.2395 9ZM18.2395 19H9.59952C6.52752 19 3.83952 16.8 3.07152 13.8C2.20752 10.1 4.31952 6.4 7.96752 5.3C8.54352 5.1 9.11952 5 9.69552 5C10.8475 5 11.9035 5.3 12.9595 5.9C14.4955 6.8 15.6475 8.4 16.1275 10.2C16.2235 10.6 16.6075 11 17.0875 11H18.2395C20.3515 11 22.0795 12.8 22.0795 15C22.0795 17.2 20.3515 19 18.2395 19Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCloud);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconCloud.c91cbfe05c17dc410c51a079ace2cd4b.svg";